'use client'

import { SanityAssetDocument } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { styles, ImageListVariants } from './ImageList.css'
import { AppTitle } from '@otomoro/components/shared/AppTitle'
import { SanityButtonProps } from "@otomoro/components/shared/Button"
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { useState } from 'react'
import clsx from 'clsx'
import { AnimatePresence, motion } from "framer-motion"
import { SectionHeader } from "@otomoro/components/shared/SectionHeader"

interface ImageListProps extends ImageListVariants {
	tag: string
	title: PortableTextObject
	imageList: {
		title: string
		primaryText: PortableTextObject
		secondaryText: PortableTextObject
		thumbnail: SanityAssetDocument
		primaryButton: SanityButtonProps
		secondaryButton: SanityButtonProps
	}[]
}

export const ImageList: React.FC<ImageListProps> = ({ tag, title, imageList }) => {
	const [activeIndex, setActiveIndex] = useState(0);

	if (!imageList) return null

	const { base, imageContainer, image, list, itemStyle, headline, wrapper } = styles()

	return (
		<section className={base()}>
			<SectionHeader tag={tag} title={title} />
			<div className={wrapper()}>
				<div className={imageContainer()}>
					{imageList.map((item, index) => (
						<AnimatePresence key={index}>
							{activeIndex === index && (
								<motion.div
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									exit={{ opacity: 0 }}
								>
									<SanityImage
										aria-labelledby={`title_${index}`}
										className={image()}
										image={item.thumbnail.image}
										alt={item.thumbnail.alt}
										sizes='(max-width: 768px) 80vw, (max-width: 1200px) 50vw, 60vw'
									/>
								</motion.div>
							)}
						</AnimatePresence>
					))}
				</div>
				<ul className={list()}>
					{imageList.map((item, index) =>
						<li
							onMouseOver={() => setActiveIndex(index)}
							onFocus={() => setActiveIndex(index)}
							className={clsx(itemStyle(), activeIndex === index ? 'border-mainPink [&+li]:border-mainPink' : 'border-color-black')}
							key={index}
							tabIndex={0}
						>
							<AppTitle
								as="h3"
								id={`title_${index}`}
								color={activeIndex === index ? 'mainPink' : 'black'}
								textTransform="uppercase"
								variant="h3"
								className={headline()}
							>
								{item.title}
							</AppTitle>
						</li>
					)}
				</ul>
			</div>
		</section>
	)
}
